import { useState, useCallback } from 'react';

const useToggle = (initialValue) => {
  const [toggleValue, setToggleValue] = useState(!!initialValue);

  const onToggle = useCallback(
    (value) =>
      setToggleValue((collapsed) =>
        typeof value === 'boolean' ? value : !collapsed
      ),
    []
  );

  return [toggleValue, onToggle];
};

export default useToggle;
